
export const TABLE_HEADER_INDEX = {
  HUB : 0,
  PROJECT: 1,
  DISCIPLINE: 2,
  MODEL: 3,
  LOD: 4,
  CHECK_BY: 5,
  DATE_CHECK: 6,
  GRADE: 7,
}
